export default "__VITE_ASSET__$hMAKH5h__"